import { makeAutoObservable, onBecomeObserved } from "mobx"

import { APIPagination, topupsApi } from "@src/shared/api"
import { TopupPaymentResponse } from "@src/shared/api/generated"

class TransactionsTopUpStore {
  private _topUps?: TopupPaymentResponse[] = []
  isLoading = false

  loadTopUps = async (
    offset = 0,
    order?: "asc" | "desc",
    status?: "confirmed" | "failed" | "pending",
  ): Promise<any> => {
    try {
      this.isLoading = true

      const { data: result } = await topupsApi.getTopupPayments(
        order,
        offset,
        this.pageSize,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        status,
      )

      if (result.success) {
        this._topUps = result.data?.data

        this.total = result.data?.pagination?.total

        return result.data
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false
    }
  }

  pageSize = 25

  total?: APIPagination["total"]

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "_topUps", this.loadTopUps)
  }

  get topUps() {
    return this._topUps?.map((item) => ({ key: item.id, ...item })) || []
  }
}

export const transactionsTopUpStore = new TransactionsTopUpStore()
